import { Toaster } from "react-hot-toast";
import { Navigate, Route, Routes } from "react-router-dom";

import { CallbackPage } from "./auth/CallbackPage";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { AppShell } from "./components/layout/AppShell";
import { Activity } from "./pages/Activity";
import { AdminUsers } from "./pages/AdminUsers";
import { Chat } from "./pages/Chat";
import { History } from "./pages/History";
import { Library } from "./pages/Library";
import { Login } from "./pages/Login";
import { Profile } from "./pages/Profile";
import { SessionDetail } from "./pages/SessionDetail";
import { Spend } from "./pages/Spend";

function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<CallbackPage />} />

        <Route
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route path="/chat" element={<Chat />} />
          <Route path="/history" element={<History />} />
          <Route path="/history/:sessionId" element={<SessionDetail />} />
          <Route path="/library" element={<Library />} />
          <Route path="/spend" element={<Spend />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/profile" element={<Profile />} />
        </Route>

        <Route path="/" element={<Navigate to="/chat" replace />} />
        {/* Legacy route aliases — keep external links working. */}
        <Route path="/today" element={<Navigate to="/chat" replace />} />
        <Route path="/briefs" element={<Navigate to="/history" replace />} />
        <Route path="/briefs/:sessionId" element={<Navigate to="/history" replace />} />
        <Route path="/papers" element={<Navigate to="/library" replace />} />
        <Route path="*" element={<Navigate to="/chat" replace />} />
      </Routes>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { background: "#1a1612", color: "#f7f3ea", fontFamily: "Inter, sans-serif" },
        }}
      />
    </>
  );
}

export default App;
